import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import PrivateLayout from '../layouts/PrivateLayout';
import { useCreateCall } from '../../services/calls';
import { ensureAuthorized, redirectToAuthorize } from '../../lib/ringcentral/auth';

const RingCall = () => {
  const { inviteId } = useParams();

  const join = useCreateCall(
    (res) => {
      if (res.ringCentralUrl) {
        window.location.href = res.ringCentralUrl;
      } else {
        toast.error('Meeting link not found');
      }
    },
    { onError: (err) => toast.error(err.message) },
  );

  useEffect(() => {
    (async () => {
      const authorized = await ensureAuthorized();
      if (!authorized) {
        redirectToAuthorize();
        return;
      }
      join.mutate(inviteId);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <PrivateLayout>Redirecting to RingCentral...</PrivateLayout>;
};

export default RingCall;
